<div class="container">
    <ul class="progressbar">
      <li class="active">Step 1</li>
      <li class="active">Step 2</li>
      <li class="active">Step 3</li>
      <li>Step 4</li>
      <li>Step 5</li>
    </ul>
</div>


// WEBPACK FOOTER //
// ./src/app/home/home/home.component.html